import { useSessionContext } from "supertokens-auth-react/recipe/session";
import { useUsersViewsGetCurrentUserQuery } from "@/store/airloom-generated-rtk";

interface CustomAccessTokenPayload {
  airloom_user_id?: string;
  airloom_user_email?: string;
  [key: string]: any;
}

interface CustomSessionContext {
  loading: boolean;
  doesSessionExist?: boolean;
  userId?: string;
  accessTokenPayload?: CustomAccessTokenPayload;
}

export function useUser(options?: { pollingInterval?: number }) {
  const session = useSessionContext() as CustomSessionContext;
  const authDisabled = import.meta.env.VITE_DISABLE_AUTH === "true";
  const isClientReady = typeof window !== "undefined";
  const actualSession = isClientReady ? session : { loading: true };

  const sessionReady =
    !session.loading &&
    "doesSessionExist" in session &&
    session.doesSessionExist;

  const {
    data: userResponse,
    error: userError,
    isLoading: userLoading,
    refetch: refetchUser,
  } = useUsersViewsGetCurrentUserQuery(undefined, {
    skip: authDisabled ? false : !sessionReady,
    refetchOnMountOrArgChange: true,
    pollingInterval: options?.pollingInterval,
  });

  if (authDisabled) {
    return {
      user: userResponse?.success ? userResponse.user : null,
      isLoading: userLoading,
      isAuthenticated: true,
      session: { loading: false, doesSessionExist: true },
      refetchUser,
    };
  }

  const userData = userResponse?.success ? userResponse.user : null;
  const isLoading = session.loading || userLoading;
  const isAuthenticated = sessionReady && !!userData;

  return {
    user: userData,
    isLoading,
    isAuthenticated,
    session,
    refetchUser,
  };
}
